module.exports = __webpack_public_path__ + "static/media/collection-bird-07.498b7f68.png";